export const JITAI_MESSAGE_LIST_REQUEST = 'JITAI_MESSAGE_LIST_REQUEST'
export const JITAI_MESSAGE_LIST_SUCCESS = 'JITAI_MESSAGE_LIST_SUCCESS'
export const JITAI_MESSAGE_LIST_FAIL = 'JITAI_MESSAGE_LIST_FAIL'
export const JITAI_MESSAGE_LIST_RESET = 'JITAI_MESSAGE_LIST_RESET'

export const JITAI_MESSAGE_CREATE_REQUEST = 'JITAI_MESSAGE_CREATE_REQUEST'
export const JITAI_MESSAGE_CREATE_SUCCESS = 'JITAI_MESSAGE_CREATE_SUCCESS'
export const JITAI_MESSAGE_CREATE_FAIL = 'JITAI_MESSAGE_CREATE_FAIL'
export const JITAI_MESSAGE_CREATE_RESET = 'JITAI_MESSAGE_CREATE_RESET'

export const JITAI_MESSAGE_UPDATE_REQUEST = 'JITAI_MESSAGE_UPDATE_REQUEST'
export const JITAI_MESSAGE_UPDATE_SUCCESS = 'JITAI_MESSAGE_UPDATE_SUCCESS'
export const JITAI_MESSAGE_UPDATE_FAIL = 'JITAI_MESSAGE_UPDATE_FAIL'
export const JITAI_MESSAGE_UPDATE_RESET = 'JITAI_MESSAGE_UPDATE_RESET'

export const JITAI_MESSAGE_DELETE_REQUEST = 'JITAI_MESSAGE_DELETE_REQUEST'
export const JITAI_MESSAGE_DELETE_SUCCESS = 'JITAI_MESSAGE_DELETE_SUCCESS'
export const JITAI_MESSAGE_DELETE_FAIL = 'JITAI_MESSAGE_DELETE_FAIL'
export const JITAI_MESSAGE_DELETE_RESET = 'JITAI_MESSAGE_DELETE_RESET' 

export const JITAI_VARIABLE_LIST_REQUEST = 'JITAI_VARIABLE_LIST_REQUEST'
export const JITAI_VARIABLE_LIST_SUCCESS = 'JITAI_VARIABLE_LIST_SUCCESS'
export const JITAI_VARIABLE_LIST_FAIL = 'JITAI_VARIABLE_LIST_FAIL'
export const JITAI_VARIABLE_LIST_RESET = 'JITAI_VARIABLE_LIST_RESET'

export const JITAI_VARIABLE_CREATE_REQUEST = 'JITAI_VARIABLE_CREATE_REQUEST'
export const JITAI_VARIABLE_CREATE_SUCCESS = 'JITAI_VARIABLE_CREATE_SUCCESS'
export const JITAI_VARIABLE_CREATE_FAIL = 'JITAI_VARIABLE_CREATE_FAIL'
export const JITAI_VARIABLE_CREATE_RESET = 'JITAI_VARIABLE_CREATE_RESET'

export const JITAI_VARIABLE_UPDATE_REQUEST = 'JITAI_VARIABLE_UPDATE_REQUEST'
export const JITAI_VARIABLE_UPDATE_SUCCESS = 'JITAI_VARIABLE_UPDATE_SUCCESS'
export const JITAI_VARIABLE_UPDATE_FAIL = 'JITAI_VARIABLE_UPDATE_FAIL'
export const JITAI_VARIABLE_UPDATE_RESET = 'JITAI_VARIABLE_UPDATE_RESET'

export const JITAI_VARIABLE_DELETE_REQUEST = 'JITAI_VARIABLE_DELETE_REQUEST'
export const JITAI_VARIABLE_DELETE_SUCCESS = 'JITAI_VARIABLE_DELETE_SUCCESS'
export const JITAI_VARIABLE_DELETE_FAIL = 'JITAI_VARIABLE_DELETE_FAIL'
export const JITAI_VARIABLE_DELETE_RESET = 'JITAI_VARIABLE_DELETE_RESET'

export const JITAI_DECISION_RULE_LIST_REQUEST = 'JITAI_DECISION_RULE_LIST_REQUEST'
export const JITAI_DECISION_RULE_LIST_SUCCESS = 'JITAI_DECISION_RULE_LIST_SUCCESS'
export const JITAI_DECISION_RULE_LIST_FAIL = 'JITAI_DECISION_RULE_LIST_FAIL'
export const JITAI_DECISION_RULE_LIST_RESET = 'JITAI_DECISION_RULE_LIST_RESET'

export const JITAI_DECISION_RULE_CREATE_REQUEST = 'JITAI_DECISION_RULE_CREATE_REQUEST'
export const JITAI_DECISION_RULE_CREATE_SUCCESS = 'JITAI_DECISION_RULE_CREATE_SUCCESS'
export const JITAI_DECISION_RULE_CREATE_FAIL = 'JITAI_DECISION_RULE_CREATE_FAIL'
export const JITAI_DECISION_RULE_CREATE_RESET = 'JITAI_DECISION_RULE_CREATE_RESET'

export const JITAI_DECISION_RULE_UPDATE_REQUEST = 'JITAI_DECISION_RULE_UPDATE_REQUEST'
export const JITAI_DECISION_RULE_UPDATE_SUCCESS = 'JITAI_DECISION_RULE_UPDATE_SUCCESS'
export const JITAI_DECISION_RULE_UPDATE_FAIL = 'JITAI_DECISION_RULE_UPDATE_FAIL'
export const JITAI_DECISION_RULE_UPDATE_RESET = 'JITAI_DECISION_RULE_UPDATE_RESET'

export const JITAI_DECISION_RULE_DELETE_REQUEST = 'JITAI_DECISION_RULE_DELETE_REQUEST'
export const JITAI_DECISION_RULE_DELETE_SUCCESS = 'JITAI_DECISION_RULE_DELETE_SUCCESS'
export const JITAI_DECISION_RULE_DELETE_FAIL = 'JITAI_DECISION_RULE_DELETE_FAIL'
export const JITAI_DECISION_RULE_DELETE_RESET = 'JITAI_DECISION_RULE_DELETE_RESET'

export const JITAI_RESP_LIST_REQUEST = 'JITAI_RESP_LIST_REQUEST'
export const JITAI_RESP_LIST_SUCCESS = 'JITAI_RESP_LIST_SUCCESS'
export const JITAI_RESP_LIST_FAIL = 'JITAI_RESP_LIST_FAIL'
export const JITAI_RESP_LIST_RESET = 'JITAI_RESP_LIST_RESET'

export const JITAI_RESP_CREATE_REQUEST = 'JITAI_RESP_CREATE_REQUEST'
export const JITAI_RESP_CREATE_SUCCESS = 'JITAI_RESP_CREATE_SUCCESS'
export const JITAI_RESP_CREATE_FAIL = 'JITAI_RESP_CREATE_FAIL'
export const JITAI_RESP_CREATE_RESET = 'JITAI_RESP_CREATE_RESET'

export const JITAI_RESP_UPDATE_REQUEST = 'JITAI_RESP_UPDATE_REQUEST'
export const JITAI_RESP_UPDATE_SUCCESS = 'JITAI_RESP_UPDATE_SUCCESS'
export const JITAI_RESP_UPDATE_FAIL = 'JITAI_RESP_UPDATE_FAIL'
export const JITAI_RESP_UPDATE_RESET = 'JITAI_RESP_UPDATE_RESET'

export const JITAI_RESP_DELETE_REQUEST = 'JITAI_RESP_DELETE_REQUEST'
export const JITAI_RESP_DELETE_SUCCESS = 'JITAI_RESP_DELETE_SUCCESS'
export const JITAI_RESP_DELETE_FAIL = 'JITAI_RESP_DELETE_FAIL'
export const JITAI_RESP_DELETE_RESET = 'JITAI_RESP_DELETE_RESET'

export const JITAI_SCHEDULED_TASK_LIST_REQUEST = 'JITAI_SCHEDULED_TASK_LIST_REQUEST'
export const JITAI_SCHEDULED_TASK_LIST_SUCCESS = 'JITAI_SCHEDULED_TASK_LIST_SUCCESS'
export const JITAI_SCHEDULED_TASK_LIST_FAIL = 'JITAI_SCHEDULED_TASK_LIST_FAIL'
export const JITAI_SCHEDULED_TASK_LIST_RESET = 'JITAI_SCHEDULED_TASK_LIST_RESET'

export const JITAI_RULES_USAGE_REQUEST = 'JITAI_RULES_USAGE_REQUEST'
export const JITAI_RULES_USAGE_SUCCESS = 'JITAI_RULES_USAGE_SUCCESS'
export const JITAI_RULES_USAGE_FAIL = 'JITAI_RULES_USAGE_FAIL'
export const JITAI_RULES_USAGE_RESET = 'JITAI_RULES_USAGE_RESET'

export const JITAI_EVALUATE_REQUEST = 'JITAI_EVALUATE_REQUEST'
export const JITAI_EVALUATE_SUCCESS = 'JITAI_EVALUATE_SUCCESS'
export const JITAI_EVALUATE_FAIL = 'JITAI_EVALUATE_FAIL'
export const JITAI_EVALUATE_RESET = 'JITAI_EVALUATE_RESET'

export const JITAI_PARTICIPANT_ACTIVITY_REQUEST = 'JITAI_PARTICIPANT_ACTIVITY_REQUEST'
export const JITAI_PARTICIPANT_ACTIVITY_SUCCESS = 'JITAI_PARTICIPANT_ACTIVITY_SUCCESS'
export const JITAI_PARTICIPANT_ACTIVITY_FAIL = 'JITAI_PARTICIPANT_ACTIVITY_FAIL'
export const JITAI_PARTICIPANT_ACTIVITY_RESET = 'JITAI_PARTICIPANT_ACTIVITY_RESET'